import { Pipe, PipeTransform } from '@angular/core';
/*
 * Pipe to filter list of FAQs while user is typing
*/
@Pipe({name: 'search'})
export class SearchPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    } 
    if (!searchText) {
      return items; 
    } 
    searchText = searchText.toLowerCase();
    return items.filter( it => {
      return it.title.rendered.toLowerCase().includes(searchText);
    });
   }

}


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/pipes/search.pipe.ts